import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import Tabs, { Tab, TabList } from '@atlaskit/tabs';

const i18n = defineMessages({
	peopleWithAccessLabel: {
		id: 'share-and-restrict-dialog.specific-access-tabs.people-with-access',
		defaultMessage: 'People with access',
		description: 'Label for tab for people with access',
	},
	requestsLabel: {
		id: 'share-and-restrict-dialog.specific-access-tabs.requests',
		defaultMessage: 'Requests',
		description: 'Label for tab for Requests',
	},
});

export type SpecificAccessTabsProps = {
	tabSelection?: number;
	setTabSelection?: (tabSelection: number) => void;
};

export const SpecificAccessTabs = ({ setTabSelection, tabSelection }: SpecificAccessTabsProps) => {
	return (
		<Tabs onChange={setTabSelection} selected={tabSelection} id="controlled">
			<TabList>
				<Tab testId="specific-access-tab-people">
					<FormattedMessage {...i18n.peopleWithAccessLabel} />
				</Tab>
				<Tab testId="specific-access-tab-requests">
					<FormattedMessage {...i18n.requestsLabel} />
				</Tab>
			</TabList>
		</Tabs>
	);
};
